import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16f59894"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "w-column-primary" }
const _hoisted_3 = { class: "w-topbar-aux" }
const _hoisted_4 = { class: "tech-flex" }
const _hoisted_5 = { class: "column-content" }
const _hoisted_6 = { class: "calendar" }
const _hoisted_7 = { class: "column-content" }
const _hoisted_8 = { style: {"margin-top":"0px"} }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tech-flex" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-column-aux" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-topbar-aux-2" }, "Info")
], -1))

import UserEdeavoursControl from '@/components/Workspaces/users/_spec/UserEdeavoursControl.vue'
import { onMounted, reactive, watch } from 'vue'
import { useAppContext } from '../_tech';
import { Sunrise } from '@/logic/_infra/time';
import { MeetingRmodel } from '@/app.context/workspace/Event';
import EventsComponent from '@/components/Workspaces/EventsComponent.vue'
import AppointmentCreator from '@/components/Workspaces/_spec/AppointmentCreator.vue';
import { WorkspaceRmodel } from '@/app.context/workspace.rmodel';
import { endeavours as endeavours_get } from '@/controllers/workspaces/user.controller.workspace'
import { symlinkSync } from 'fs';
import sys from '@/sys';


export default /*#__PURE__*/_defineComponent({
  __name: 'CalendarSubview',
  setup(__props) {

const model: { date: Date | null, events: MeetingRmodel[], workspace: WorkspaceRmodel | null } = reactive({ date: new Date(), events: [], workspace: null })

const context = useAppContext()

const endeavours = endeavours_get(context)



//setup()

async function setup(): Promise<void> {

  try {

    const workspace = context.cursor.workspace;

    if (workspace != null) {

      model.workspace = context.cursor.workspace;

      const wid = workspace.wid

      if (model.date != null) {

        const sunrise = Sunrise.DateAsSunrise(model.date)

        const events_dtos = await context.service.workspaceEvents(wid, sunrise)

        model.events.replaceWith(events_dtos.map(e => MeetingRmodel.instance(e, workspace)))


      }


    }
  } catch (error) {

    sys.exception(error)
  }
}

watch(() => context.cursor.workspace, setup);

onMounted(setup)

watch(() => model.date, setup)


return (_ctx: any,_cache: any) => {
  const _component_v_date_picker = _resolveComponent("v-date-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(UserEdeavoursControl, {
          items: _unref(endeavours),
          class: "endeavours"
        }, null, 8, ["items"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_v_date_picker, {
              modelValue: model.date,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model.date) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createVNode(AppointmentCreator, {
            style: {"margin-top":"1em"},
            workspace: model.workspace,
            date: model.date,
            storage: _unref(context).storages.workspace
          }, null, 8, ["workspace", "date", "storage"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("h2", _hoisted_8, _toDisplayString(model.date?.toDateString()), 1),
          _createVNode(EventsComponent, {
            events: model.events
          }, null, 8, ["events"]),
          _hoisted_9
        ])
      ])
    ]),
    _hoisted_10
  ]))
}
}

})